var exports = {
  "Q": "MacPermissionsModal.module__content___QU8ydj",
};

module.exports = exports;
